/**
 * How long a failed local-gateway probe stands before ./index may probe that
 * origin again.
 *
 * A failed probe used to be the verdict for the life of the tab. That is wrong
 * whenever the failure was temporary — the commonest being a laptop that just
 * changed network, whose gateway name still pointed at the old address for the
 * minute or two the cloud takes to republish it — and it cost one sales demo a
 * whole session of reading every image from the cloud. So the verdict expires,
 * on a backoff: soon after the first failure (a moved node's new address is
 * usually published within a minute or two), then less often, so a gateway that
 * is genuinely down or unreachable from this browser costs a handful of
 * 1.5-second probes an hour rather than a steady stream.
 */
const RETRY_DELAYS_MS = [30_000, 60_000, 120_000, 300_000];
/**
 * The wait before the next probe, given how many probes of this origin have
 * failed in a row since it was last reachable (or since the network last
 * changed): 30 s, 1 min, 2 min, then every 5 min.
 */
export function probeRetryDelayMs(consecutiveFailures) {
    const failures = Number.isFinite(consecutiveFailures) ? Math.floor(consecutiveFailures) : 0;
    const index = Math.min(Math.max(0, failures), RETRY_DELAYS_MS.length - 1);
    return RETRY_DELAYS_MS[index];
}
